import React from 'react'
import PropTypes from 'prop-types'
import NavigationHelper from 'layers/navigation/navigationHelper'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContextLegacy'
import { SITE_QUERY_PARAM } from 'layers/content/v2/Hocs/withSiteContextLegacy/constants'

import { DASHBOARD_ROUTE, isHighSchoolDashboard } from 'utils/highschoolHelpers'
import {
  isK5Dashboard,
  isMiddleSchoolDashboard,
} from 'utils/routing/routeHelpers'

import SelectSiteModal from './component'

const SelectSiteModalContainer = props => {
  const {
    activeSites,
    currentSite,
    customRoute,
    handleClose,
    navigationEvent,
    setActiveSite,
    show,
  } = props || {}

  const redirectTo = customRoute || DASHBOARD_ROUTE

  const handleSiteChange = site => {
    const { id } = site || {}

    setActiveSite(id)

    // Determine if we should preserve the current page or redirect to dashboard
    const isOnDashboard =
      isHighSchoolDashboard() || isMiddleSchoolDashboard() || isK5Dashboard()

    let newUrl
    if (!id) {
      // If no site ID, always go to dashboard
      newUrl = DASHBOARD_ROUTE
    } else if (isOnDashboard) {
      // If already on dashboard, navigate to the appropriate dashboard with site
      newUrl = `${redirectTo}?${SITE_QUERY_PARAM}=${id}`
    } else {
      // Preserve current page, just update the site parameter
      const currentUrl = new URL(window.location.href)
      currentUrl.searchParams.set(SITE_QUERY_PARAM, id)
      newUrl = `${currentUrl.pathname}${currentUrl.search}`
    }

    navigationEvent(newUrl, NavigationHelper.types.OPEN)
  }

  // If activeSites is not available, don't render the modal
  if (!activeSites) {
    return null
  }

  return (
    <SelectSiteModal
      activeSites={activeSites?.map(s => ({ name: s?.name, id: s?.id }))}
      currentSite={currentSite}
      handleClose={handleClose}
      handleSiteChange={handleSiteChange}
      show={show}
    />
  )
}

SelectSiteModalContainer.propTypes = {
  activeSites: PropTypes.array.isRequired,
  currentSite: PropTypes.object,
  customRoute: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  navigationEvent: PropTypes.func.isRequired,
  setActiveSite: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}

export default withSiteContext(SelectSiteModalContainer)
